import { render, staticRenderFns } from "./DialogHost.vue?vue&type=template&id=12548e64&scoped=true"
import script from "./DialogHost.vue?vue&type=script&lang=js"
export * from "./DialogHost.vue?vue&type=script&lang=js"
import style0 from "./DialogHost.vue?vue&type=style&index=0&id=12548e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12548e64",
  null
  
)

export default component.exports